<template>
  <el-form :model="ruleForm" ref="ruleForm" label-position="top">
    <el-row :gutter="5">
      <el-col :xs="15" :sm="10" :md="10" :lg="8" :xl="8">
        <el-form-item :label="$t('licenca')" prop="customer">
          <CustomerList v-model="ruleForm.customer" v-bind:current="[ruleForm.customer]" :customerType="2"
            v-on:selected="selected" />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="5">
      <el-col :xs="24" :sm="18" :md="16" :lg="12" :xl="12">
        <el-form-item :label="$t('nome')" prop="name">
          <el-input maxlength="255" ref="name" v-model="ruleForm.name"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="5">
      <el-col :xs="24" :sm="18" :md="16" :lg="12" :xl="12">
        <el-form-item :label="$t('tipo')" prop="type">
          <el-radio-group v-model="ruleForm.type">
            <el-radio label="shipping">{{
              $t("transportadora")
            }}</el-radio>
            <el-radio label="motocycle">{{ $t("motoboy") }}</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="5">
      <UploadLogo :label="$t('logo')" :content="ruleForm.logo" @uploaded="upload" />
    </el-row>
    <el-row :gutter="5">
      <el-col :xs="24" :sm="18" :md="18" :lg="8" :xl="8">
        <el-form-item label="Spred (%)" prop="spred">
          <el-input-number type="number" v-model="ruleForm.value" ref="money" :min="1" :max="100"></el-input-number >
        </el-form-item>
      </el-col>
      <el-col :xs="15" :sm="10" :md="10" :lg="5" :xl="5">
        <el-form-item :label="$t('ativo')" prop="active" class="is-required">
          <el-switch v-model="ruleForm.active" inactive-color="#ff4949"></el-switch>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="5">
      <el-col :xs="24" :sm="20" :md="18" :lg="12" :xl="12">
        <el-form-item :label="$t('base-url')" prop="endpoint">
          <el-input maxlength="255" v-model="ruleForm.endpoint"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
import CustomerList from "@/xpost/views/register/customer/CustomerList";
import ShippingIntegrationList from '../../integration/ShippingIntegrationList';
import UploadLogo from "./UploadLogo.vue";

export default {
  components: {
    CustomerList,
    ShippingIntegrationList,
    UploadLogo
  },
  computed: {
    data() {
      return this.ruleForm;
    }
  },
  name: "ShippingAddFormHeader",
  data() {
    return {
      ruleForm: {
        name: "",
        service: "",
        value: 0,
        active: true,
        logo: "",
        customer: "",
        endpoint: "",
        type: "shipping",
      },
    };
  },
  methods: {
    upload(data) {
      this.ruleForm.logo = data.content;
    },
    selected(customer) {
      this.ruleForm.customer = customer;
    },
    services(service) {
      this.ruleForm.service = service;
    }
  }
};
</script>
